<script>
    import relatorioServico from '../relatorio.servico';
    import projetoServico from '~modulos/projeto/servico';

    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';
    import 'vue-strap/dist/vue-strap-lang';

    import { datepicker } from 'vue-strap';
    import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
    import TelaCheia from '~componentes/TelaCheia.vue';

    export default {
        components: { datepicker, CabecalhoRelatorio, TelaCheia },
        data() {
            return {
                filtros: {
                    idProjeto: '',
                    dataInicio: moment(new Date()).format('DD/MM/YYYY'),
                    dataFim: moment(new Date()).format('DD/MM/YYYY'),
                    idSolWebCompra: '',
                    idSolWebPassagem: '',
                    numeroPedidoCompra: '',
                },
                projetos: [],
                relatorio: [],
                projeto: null,
                dataInicio: '',
                dataFim: '',
                validarCampos: 'required',
                requiredCampos: true,
            }
        },
        methods: {
            listaDeProjetos() {
                return projetoServico
                    .listaDeProjetosPermissao("RelPedidoCompra")
                    .then(projetos => {
                        this.projetos = projetos;
                    });
            },
            gerar() {
                this.relatorio = {};
                this.setarProjeto();
                this.dataInicio = this.filtros.dataInicio;
                this.dataFim = this.filtros.dataFim;

                this.$validator
                    .validateAll()
                    .then(valido => {
                        if (!valido) throw new Error("validacao");

                        $('#gerar').button('loading');

                        return relatorioServico.pedidosCompra(this.filtros)
                    })
                    .then(resultado => {
                        this.relatorio = resultado;

                        $('#gerar').button('reset');

                        if (resultado.length === 0) {
                            this.$swal('', 'Nenhum resultado encontrado.', 'info');
                        } else {
                            this.$nextTick(() => {
                                $('html, body').animate({
                                    scrollTop: $('#relatorio').offset().top
                                }, 800);
                            });
                        }
                    })
                    .catch(erro => {
                        $('#gerar').button('reset');

                        if (erro.status === 422) {
                            this.$mensagemErro(erro, erro.body.message);
                        } else {
                            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
                        }
                    });
            },
            gerarExcel() {
                this.relatorio = {};
                this.setarProjeto();
                this.dataInicio = this.filtros.dataInicio;
                this.dataFim = this.filtros.dataFim;

                this.$validator
                    .validateAll()
                    .then(valido => {
                        if (!valido) throw new Error("validacao");

                        $('#gerar-excel').button('loading');

                        return relatorioServico.pedidosCompraExcel(this.filtros)
                    })
                    .then(arquivo => {
                        $('#gerar-excel').button('reset');

                        if (arquivo === '') {
                            this.$swal('', 'Nenhum resultado encontrado.', 'info');
                        } else {
                            arquivo.download();
                        }
                    })
                    .catch(erro => {
                        $('#gerar-excel').button('reset');

                        this.$mensagemErro(erro, 'Erro ao gerar relatório.');
                    });
            },
            setarProjeto() {
                if (this.filtros.idProjeto == '')
                    return;

                const idProjeto = this.filtros.idProjeto;

                this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null;
            },
            total(item) {
                let desconto = 0;

                desconto = this.desconto(item);

                return (item.quantidade * item.valorUnitario) - desconto;
            },
            desconto(item) {
                let desconto = 0;

                if (item.descontoDinheiro) {
                    desconto = item.descontoDinheiro;
                } else if (item.descontoPercentual) {
                    desconto = (item.descontoPercentual / 100) * item.valorUnitario;
                }

                return desconto;
            },
            saldo(itens) {
                return itens.reduce((totalItem, item) => totalItem + this.total(item), 0)
            },
            requiredCamposChange() {                
                if (this.filtros.idSolWebCompra == "" && this.filtros.idSolWebPassagem == "" && this.filtros.numeroPedidoCompra == "")
                {
                    this.requiredCampos = true;
                    this.validarCampos = 'required';
                } 
                else
                {
                    this.requiredCampos = false;
                    this.validarCampos = ''; 
                }
            }
        },
        mounted() {
            this.$root.tituloDaPagina = `Relatório Pedidos de Compra`;
            this.$root.botaoAcaoTexto = 'Imprimir relatório';
            this.$root.botaoAcaoIcon = 'fa-print';
            this.$root.botaoAcaoLink = '';

            this.$root.botaoRetrocederMostrar = false;
            this.$root.botaoRetrocederRota = '';

            this.$events.on('botaoAcao', function () {
                window.print();
            });

            this.listaDeProjetos();

            const _this = this;

            //$('.datepicker input').attr('readonly', '');

            $('#projeto').select2({
                theme: "bootstrap",
                placeholder: "Selecione...",
                language: "pt-BR"
            })
                .change(function (e) {
                    _this.$set(_this.filtros, 'idProjeto', this.value);
                });
        },
        beforeDestroy() {
            this.$events.off('botaoAcao');
        },
        watch: {
          'filtros.idSolWebCompra': 'requiredCamposChange',
          'filtros.idSolWebPassagem': 'requiredCamposChange',
          'filtros.numeroPedidoCompra': 'requiredCamposChange',
        }
    }
</script>

<template>
    <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
        <form class="hidden-print" @submit.prevent="gerar">

            <div class="ibox float-e-margins">
                <div class="ibox-content">

                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('dataInicio'), 'required': requiredCampos}">
                                <label class="control-label">Período</label>

                                <datepicker id="dataInicio"
                                            v-mascara="'data-mask'"
                                            v-model="filtros.dataInicio"
                                            format="dd/MM/yyyy"
                                            placeholder="  /  /     "
                                            lang="pt-BR">
                                </datepicker>

                                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                                <label class="control-label">&nbsp; &nbsp;</label>

                                <datepicker id="dataFim"
                                            v-mascara="'data-mask'"
                                            v-model="filtros.dataFim"
                                            format="dd/MM/yyyy"
                                            placeholder="  /  /     "
                                            lang="pt-BR">
                                </datepicker>
                            </div>
                        </div>

                        <div class="col-xs-2">
                            <div class="form-group" :class="{'has-error': errors.has('idsolwebcompra')}">
                                <label class="control-label" for="protocolo">Nº solicitação web compra</label>

                                <input v-model="filtros.idSolWebCompra"
                                       type="text"
                                       id="idsolwebcompra"
                                       class="form-control"
                                       data-vv-name="idsolwebcompra"
                                       data-vv-as="nº solicitação web compra">

                                <p class="text-danger" v-show="errors.has('idsolwebcompra')">{{ errors.first('idsolwebcompra') }}</p>
                            </div>
                        </div>

                        <div class="col-xs-2">
                            <div class="form-group" :class="{'has-error': errors.has('idsolwebpassagem')}">
                                <label class="control-label" for="protocolo">Nº solicitação web passagem</label>

                                <input v-model="filtros.idSolWebPassagem"
                                       type="text"
                                       id="idsolwebpassagem"
                                       class="form-control"
                                       data-vv-name="idsolwebpassagem"
                                       data-vv-as="nº solicitação web passagem">

                                <p class="text-danger" v-show="errors.has('idsolwebpassagem')">{{ errors.first('idsolwebpassagem') }}</p>
                            </div>
                        </div>

                        <div class="col-xs-2">
                            <div class="form-group" :class="{'has-error': errors.has('numeroPedidoCompra')}">
                                <label class="control-label" for="protocolo">Nº pedido compra</label>

                                <input v-model="filtros.numeroPedidoCompra"
                                       type="text"
                                       id="numeroPedidoCompra"
                                       class="form-control"
                                       data-vv-name="numeroPedidoCompra"
                                       data-vv-as="nº pedido compra">

                                <p class="text-danger" v-show="errors.has('numeroPedidoCompra')">{{ errors.first('numeroPedidoCompra') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12">
                            <div class="form-group" :class="{'has-error': errors.has('projeto'), 'required': requiredCampos}">
                                <label class="control-label" for="projeto">Projeto</label>

                                <select id="projeto"
                                        class="form-control"
                                        v-model="filtros.idProjeto"
                                        data-vv-name="projeto"
                                        v-validate="validarCampos">
                                    <option value="">Selecione...</option>
                                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                                </select>

                                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <button id="gerar"
                                type="button"
                                class="btn btn-primary"
                                @click="gerar"
                                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                            <i class="fa fa-line-chart"></i>
                            Gerar relatório
                        </button>

                        <button id="gerar-excel"
                                type="button"
                                class="btn btn-primary"
                                @click="gerarExcel"
                                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                            <i class="fa fa-table"></i>
                            Gerar relatório em excel
                        </button>

                        <tela-cheia texto="Visualizar em tela cheia"
                                    icone="arrows-alt"
                                    v-if="Object.keys(relatorio).length !== 0">
                        </tela-cheia>
                    </div>
                </div>
            </div>
        </form>

        <cabecalho-relatorio titulo="Relatório Pedidos de Compra" borda=""></cabecalho-relatorio>

        <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatorio">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">

                        <div class="table-responsive">
                            <table class="table table-condensed no-margins" v-if="requiredCampos">
                                <thead>
                                    <tr>
                                        <th>Projeto</th>
                                        <th class="text-right">Período</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ projeto.nomeProjeto }}</td>
                                        <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table class="table relatorio table-bordered">
                                <tbody>
                                    <template v-for="compra in relatorio">
                                        <tr>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Fornecedor</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Sol. web</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Sol. compra</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Nr. Pedido</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Nr. NF.</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Pedido em</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Entrega em</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Dat NF.</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>CP</b></td>
                                            <td class="bg-muted font-bold" style=" background-color: #bdd5d4"><b>Responsável</b></td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #bdd5d442">{{ compra.fornecedor }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.idSolicitacaoCompra || '---' }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.solicitacaoCompra }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.numeroPedidoCompra }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.numeroNotaFiscal || '---' }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.dataPedido | formatarData }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.dataEntrega | formatarData('---') }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.dataNotaFiscal | formatarData('---') }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.contaPagarCriada ? 'Sim' : 'Não' }}</td>
                                            <td style="background-color: #bdd5d442">{{ compra.responsavelPedido }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="4" class="font-bold">Produto</td>
                                            <td class="font-bold">Entrega</td>
                                            <td class="font-bold text-center">Quant.</td>
                                            <td class="font-bold text-right">Valor Unit.</td>
                                            <td class="font-bold text-right">Desc.</td>
                                            <td class="font-bold text-right">Total</td>
                                            <td class="font-bold">Patrim.</td>
                                        </tr>
                                        <tr v-for="item in compra.relatorioPedidoCompraItensObjeto">
                                            <td colspan="4">{{ item.nomeProduto }} - {{ item.complementoItemPedido }}</td>
                                            <td>{{ compra.prazoEntrega }} dia(s)</td>
                                            <td class="text-center">{{ item.quantidade | formatarNumero }}</td>
                                            <td class="text-right">{{ item.valorUnitario | formatarNumero }}</td>
                                            <td class="text-right">{{ desconto(item) | formatarNumero }}</td>
                                            <td class="text-right">{{ total(item) | formatarNumero }}</td>
                                            <td>{{ item.patrimonio ? 'Sim' : 'Não' }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="8" class="bg-muted font-bold text-right" style=" background-color: #bdd5d442"><b>Total:</b></td>
                                            <td class="bg-muted font-bold text-right" style=" background-color: #bdd5d442">{{ saldo(compra.relatorioPedidoCompraItensObjeto) | formatarNumero }}</td>
                                            <td style="background-color: #bdd5d442"></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/PedidosCompra.vue